import { setCurrentStep } from "@/store/wizard";
import { FAQItem, HelpPortalConfig } from "@WealthierAI/core";

export const employeeFAQs: FAQItem[] = [
  {
    title: "What is the Sootchy Education Program (SEP)?",
    content:
      "The Sootchy Education Savings Program helps you save for qualified education expenses with automated payroll deductions, employer matching contributions, and tax-advantaged growth. Whether you're planning for college, vocational training, or continuing education, Sootchy helps you reach your goals.",
  },
  {
    title: "Who is eligible to participate in SEP?",
    content:
      "Employees who are invited by their employer to join SEP can participate. The program is designed to help parents, guardians, and employees save for their children's education or their own through a 529 savings plan.",
  },
  {
    title: "How does SEP work?",
    content:
      "Employees contribute to a 529 account through automated payroll deductions, with the option for employers to match contributions. SEP also allows for additional funding from friends and family Gifting, helping employees save more efficiently.",
  },
  {
    title: "What are the benefits?",
    content: `
      Employer Matching: Employers can match employee contributions, boosting savings potential.

Tax Advantages: Contributions grow tax-deferred, and withdrawals for qualified expenses are tax-free.

Easy Setup: SEP is easy to set up and manage, with online access and automated payroll deductions.
      `,
  },
  {
    title: "How do I get started with SEP?",
    content:
      "To get started, you need to receive an invite from your employer. Once you've received the invite, you can set up your account online in just a few minutes by entering your personal and beneficiary details.",
  },
  {
    title: "Can I change my beneficiary?",
    content:
      "Yes, you can change your beneficiary at any time. You can transfer the funds to another family member if needed.",
  },
  {
    title: "Can I use SEP funds for anything other than education?",
    content:
      "SEP funds are intended to be used for qualifying education expenses, including tuition, fees, room and board, and supplies. For non-education expenses, taxes and withdrawal penalties may apply.",
  },
  {
    title: "Is there a minimum contribution amount?",
    content:
      "There is no minimum required contribution amount, and contributions can be made through small, consistent payroll deductions, making it easy for employees to save.",
  },
  {
    title: "Can I contribute to SEP if I don't have children?",
    content:
      "Yes, if you are saving for your own education or any other eligible beneficiary, you can participate in the program and start saving for your future.",
  },
];

export const employeeHelpConfig: HelpPortalConfig = {
  authPagePatterns: ["/forgot-password", "/login"],
  onBackClick: (navigate, location, dispatch) => {
    const navigationState = location.state as
      | { from?: string; wizardStep?: number }
      | undefined;

    if (navigationState && navigationState.from) {
      if (navigationState.wizardStep !== undefined) {
        dispatch(setCurrentStep(navigationState.wizardStep));
      }
      navigate(navigationState.from, { replace: true });
    } else {
      navigate(-1);
    }
  },
};
